import { UseQueryResult, skipToken, useQuery } from '@tanstack/react-query';

import { CaseModel } from 'models/CaseModel';

import { HttpRequestOptionsType } from '../../../core/api/types';
import { ApiRequestError } from '../../../core/api/types/ApiRequestError';
import { useApiClient } from '../../api';
import { AuthenticationScheme, useAuthentication } from '../../auth';

export const CASE_QUERY_KEY = 'cases';

export const useCasesQuery = (
  patientId: number | undefined | null,
  options?: HttpRequestOptionsType,
  queryOptions?: { enabled?: boolean },
): UseQueryResult<CaseModel[], ApiRequestError> => {
  const apiClient = useApiClient();
  const { activeScheme } = useAuthentication();

  return useQuery<CaseModel[], ApiRequestError>({
    queryKey: [CASE_QUERY_KEY, patientId],
    queryFn:
      // Skip cases query in share mode - cases are not needed for share functionality
      activeScheme === AuthenticationScheme.SHARE
        ? skipToken
        : async () => {
            if (!patientId) {
              // Or throw an error, depending on desired behavior when patientId is missing
              return Promise.resolve([]);
            }
            // The actual error thrown by caseClient methods will be ApiRequestError or UnauthorizedError
            return apiClient.caseClient.getCases(patientId, options);
          },
    // Enable the query only when patientId is a valid number and not in share mode
    enabled: typeof patientId === 'number' && !isNaN(patientId) && activeScheme !== AuthenticationScheme.SHARE && (queryOptions?.enabled ?? true),
    // Add other react-query options as needed (staleTime, cacheTime, etc.)
  });
};
